import { render, staticRenderFns } from "./InvoiceIssuerEdit.vue?vue&type=template&id=22b4b024&scoped=true&"
import script from "./InvoiceIssuerEdit.vue?vue&type=script&lang=js&"
export * from "./InvoiceIssuerEdit.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceIssuerEdit.vue?vue&type=style&index=0&id=22b4b024&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b4b024",
  null
  
)

export default component.exports